var _defs, _rect, _rect2, _rect3, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCruzetas = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 75 75",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-1, .cls-2, .cls-3 {\n        fill: none;\n        stroke: #171954;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2 {\n        stroke-width: 3.39px;\n      }\n\n      .cls-3 {\n        stroke-width: 3px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.45,
    y: 12.35,
    width: 6.47,
    height: 6.47
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 35.45,
    y: 25.63,
    width: 6.47,
    height: 41.12
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.45,
    y: -4.05,
    width: 6.47,
    height: 52.56,
    transform: "translate(16.46 60.91) rotate(-90)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m22.51,25.46c4.31,6.19,8.62,12.39,12.94,18.58v-5.28c-3.06-4.38-6.13-8.76-9.19-13.14-1.25-.06-2.5-.11-3.74-.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m54.85,25.46c-4.31,6.19-8.62,12.39-12.94,18.58v-5.28c3.06-4.38,6.13-8.76,9.19-13.14,1.25-.06,2.5-.11,3.74-.17Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCruzetas);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/CRUZETAS.fec541dc9e5754075fbf79a33743544c.svg";